import type { Theme } from '@mui/material';

import { DownloadState } from 'src/constants/downloadManager';

export const styles = {
  root: (theme: Theme) => ({
    marginBottom: theme.spacing(4),
  }),
  element: (theme: Theme, state: DownloadState) => ({
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    height: theme.spacing(4),
    background: theme.colors.neutral[50],
    paddingLeft: theme.spacing(1),
    ...((state === DownloadState.READY ||
      state === DownloadState.DOWNLOADING) && {
      background: theme.colors.primary[50],
    }),
    ...(state === DownloadState.FINISHED && {
      background: theme.colors.tertiary[50],
    }),
  }),
  name: (theme: Theme) => ({
    textOverflow: 'ellipsis',
    color: theme.colors.neutral[600],
    fontWeight: 400,
    overflow: 'hidden',
    textWrap: 'nowrap',
  }),
  cancelButton: () => ({
    marginLeft: 'auto',
  }),
  category: (theme: Theme) => ({
    mb: 1,
    mt: 2,
    color: theme.colors.neutral[600],
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '18px',
  }),
};
